import './Button.scss';

import SkapaButton, { ButtonProps as SkapaButtonProps } from '@ingka/button';
import { RefAttributes } from 'react';

import { PREFIX } from '../constants/constants';

const Button = (props: SkapaButtonProps & RefAttributes<HTMLAnchorElement | HTMLButtonElement>) => (
  <SkapaButton prefix={PREFIX} {...props} />
);

export default Button;
